import * as React from "react";
import { WebsocketContext } from "./WebsocketProvider";
import { TimerContext } from "./TimerProvider";
import LabeledPlay from "./LabeledPlay";
import PublicRoomsPane from "./PublicRoomsPane";
import { isWasmAvailable } from "./detectWasm";
import { useTranslation } from "./i18n";
var JoinRoom = function (props) {
    var _a = React.useState(false), editable = _a[0], setEditable = _a[1];
    var _b = React.useState(props.room_name.length !== 16), shouldGenerate = _b[0], setShouldGenerate = _b[1];
    var send = React.useContext(WebsocketContext).send;
    var setTimeout = React.useContext(TimerContext).setTimeout;
    var _c = useTranslation(), t = _c.t, lang = _c.lang;
    var handleChange = function (event) {
        return props.setName(event.target.value.trim());
    };
    var handleRoomChange = function (event) {
        return props.setRoomName(event.target.value.trim());
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        if (props.name.length > 0 && props.room_name.length === 16) {
            send({
                room_name: props.room_name,
                name: props.name,
                disable_compression: !isWasmAvailable(),
            });
        }
    };
    var editableRoomName = (React.createElement("input", { type: "text", className: "sj-input", placeholder: t("join.enterRoom"), value: props.room_name, onChange: handleRoomChange, maxLength: 16 }));
    var nonEditableRoomName = (React.createElement("span", { className: "sj-chip cursor-pointer font-mono text-base", title: "Set the room name", onClick: function (evt) {
            evt.preventDefault();
            setEditable(true);
        } }, props.room_name));
    var generateRoomName = function () {
        var arr = new Uint8Array(8);
        window.crypto.getRandomValues(arr);
        setShouldGenerate(false);
        props.setRoomName(Array.from(arr, function (d) { return ("0" + d.toString(16)).slice(-2); }).join(""));
    };
    if (shouldGenerate) {
        setTimeout(generateRoomName, 0);
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "mb-4 flex justify-center" },
            React.createElement(LabeledPlay, { cards: ["🃟", "🃟", "🃏", "🃏"], trump: { NoTrump: {} }, label: null })),
        React.createElement("form", { className: "join-room flex flex-col gap-4", onSubmit: handleSubmit },
            React.createElement("label", { className: "flex flex-col gap-1" },
                React.createElement("span", { className: "text-sm font-semibold text-[var(--text-secondary)]" }, t("join.roomName")),
                React.createElement("span", { className: "flex items-center gap-2" },
                    editable ? editableRoomName : nonEditableRoomName,
                    React.createElement("button", { type: "button", className: "sj-btn sj-btn-ghost !min-h-[40px] !px-3 !text-[var(--text-primary)]", title: t("join.generateRoom"), "aria-label": t("join.generateRoom"), onClick: function () { return generateRoomName(); } }, "\uD83C\uDFB2"))),
            React.createElement("label", { className: "flex flex-col gap-1" },
                React.createElement("span", { className: "text-sm font-semibold text-[var(--text-secondary)]" }, t("join.playerName")),
                React.createElement("input", { type: "text", className: "sj-input", placeholder: t("join.enterName"), value: props.name, onChange: handleChange, autoFocus: true })),
            React.createElement("button", { type: "submit", className: "sj-btn sj-btn-primary w-full", disabled: props.room_name.length !== 16 ||
                    props.name.length === 0 ||
                    props.name.length > 32 }, t("join.join"))),
        React.createElement("div", { className: "mt-5 space-y-2 text-sm text-[var(--text-secondary)]" },
            React.createElement("p", null, t("join.intro")),
            React.createElement("p", null,
                React.createElement("a", { href: "rules.html?lang=".concat(lang), target: "_blank", rel: "noreferrer", className: "text-[var(--accent)] underline" }, t("join.readRules")),
                " · ",
                React.createElement("a", { href: "strategy.html?lang=".concat(lang), target: "_blank", rel: "noreferrer", className: "text-[var(--accent)] underline" }, t("join.readStrategy"))),
            React.createElement("p", null, t("join.shareIntro"))),
        React.createElement(PublicRoomsPane, { setRoomName: props.setRoomName })));
};
export default JoinRoom;
